import { render, staticRenderFns } from "./ipWhiteAdd.vue?vue&type=template&id=364ad028&scoped=true&"
import script from "./ipWhiteAdd.vue?vue&type=script&lang=js&"
export * from "./ipWhiteAdd.vue?vue&type=script&lang=js&"
import style0 from "./ipWhiteAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ipWhiteAdd.vue?vue&type=style&index=1&id=364ad028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ad028",
  null
  
)

export default component.exports